import Vue from "vue";

try {
  var rest = require("@/services/crud").default;
} catch (err) {
  try {
    var rest = require("@/framework/services/crud").default;
  } catch (err) {}
}

const Api = global.Api;

try {
  var Export2Multi = require("@/vendor/Export2Multi");
} catch (err) {
  try {
    var Export2Multi = require("@/framework/vendor/Export2Multi");
  } catch (err) {}
}

export default class {
  constructor(module, lista, params, othis) {
    this.module = module;
    this.lista = lista;
    this.params = params;
    this.othis = othis;
  }

  getSocketIO() {
    if (global.config.socketiocrud_force === true) return this.othis.$socket;
    return undefined;
  }

  _trataTpl(origtplparam, camposbase, action) {
    let campos = _.clone(camposbase);
    let tplparam = origtplparam || "";

    let actiontpl = action;
    if (actiontpl == "flow") {
      if (this.metadata.flowstatus != null) {
        let busca = actiontpl + " " + this.metadata.flowstatus;
        if (tplparam.indexOf("===" + busca + "===") != -1) {
          actiontpl = busca;
        } else if (tplparam.indexOf("===" + "flow" + "===") != -1) {
          actiontpl = "flow";
        } else {
          actiontpl = "edit";
        }
      }
    }

    if (tplparam.indexOf("===") != -1) {
      let basic = tplparam.split("===")[0].trim();

      if (tplparam.indexOf("===" + actiontpl + "===") != -1) {
        basic = tplparam.split("===" + actiontpl + "===")[1].trim();
        basic = basic.split("===")[0].trim();
      }
      tplparam = basic;
    }

    const de = tplparam.indexOf("{{");
    const ate = tplparam.indexOf("}}");

    let listanomes = null;
    if (de !== -1) {
      listanomes = tplparam.substr(de + 2, ate - de - 2).replace(/\n/g, ",");
      listanomes = listanomes
        .split(",")
        .map(v => v.trim())
        .filter(v => v != "");
      tplparam = tplparam.substr(0, de) + tplparam.substr(ate + 2);

      campos.sort((a, b) => {
        let ia = listanomes.indexOf(a.cmp_coluna);
        let ib = listanomes.indexOf(b.cmp_coluna);
        if (ia == -1 && ib != -1) return 1;
        if (ia != -1 && ib == -1) return -1;
        if (ia == -1 && ib == -1) return 0;
        if (ia < ib) return -1;
        if (ia > ib) return 1;
        return 0;
      });
    }

    let tplista = [];
    for (let i = 0; i < 99; i++) tplparam += "\n4,4,4";

    let linhas = tplparam.split("\n");
    let dividers = [];
    let others = [];
    let c = 0;
    for (let l of linhas) {
      l = l.trim();
      if (l == "") continue;

      if (l.substr(0, 6) == "+secao") {
        others.push([c, l.substr(0, 6), l.substr(6).trim()]);
        continue;
      }
      if (l.substr(0, 6) == "-secao") {
        others.push([c, l.substr(0, 6)]);
        continue;
      }
      if (l.substr(0, 4) == "+aba") {
        others.push([c, l.substr(0, 4), l.substr(4).trim()]);
        continue;
      }

      let ns = l.split(",");
      for (let i in ns) {
        tplista.push(ns[i].trim());
        c++;
      }
      dividers.push(c);
    }
    let tpdiv = dividers;

    let camposadd = [];
    c = 0;
    for (let i in campos) {
      if (action == "new" && campos[i].cmp_add == false) continue;
      if (action == "edit" && campos[i].cmp_edit == false) continue;

      if (action == "view" && campos[i].cmp_view == false) continue;

      if (
        action == "flow" &&
        campos[i].cmp_flow.split(",").filter(v => v == this.metadata.flowstatus)
          .length == 0
      )
        continue;

      if (tpdiv.indexOf(c) != -1) {
        camposadd.push({
          m: "DIV"
        });
      }
      let w = others.filter(e => e[0] == c);
      for (let wi of w) {
        camposadd.push({
          m: "O",
          o: [wi[1], wi[2]]
        });
      }
      campos[i].tpl = tplista[c];
      camposadd.push(campos[i]);

      c++;
    }

    let abas = [
      {
        nome: null,
        secoes: [
          {
            nome: null,
            campos: []
          }
        ]
      }
    ];
    let w = 0;
    let s = 0;
    for (let no of camposadd) {
      if (no.m == "O" && no.o[0] == "+aba") {
        w++;
        abas[w] = {
          nome: no.o[1],
          secoes: []
        };
        s = 0;
        abas[w].secoes[s] = {
          nome: null,
          campos: []
        };
      } else {
        if (no.m == "O" && no.o[0] == "+secao") {
          s++;
          abas[w].secoes[s] = {
            nome: no.o[1],
            campos: []
          };
        } else if (no.m == "O" && no.o[0] == "-secao") {
          s++;
          abas[w].secoes[s] = {
            nome: null,
            campos: []
          };
        } else abas[w].secoes[s].campos.push(no);
      }
    }

    return abas;
  }

  editItem(item, lang = null) {
    this.lista.campos = _.clone(this.listaFixaCampos);

    if (this.embed == null) {
      let pa = {
        path: `/admin/app/${this.module}/${this.sid}/edit/${item.id}`
      };

      if (lang != null) pa.query = { lang: lang };
      this.$router.push(pa);
    } else {
      this.embed.params = {
        module: this.module,
        sid: this.sid,
        action: "edit",
        id: item.id
      };
      if (lang != null) this.embed.query = { lang: lang };
    }
  }

  flowItem(item) {
    this.lista.campos = _.clone(this.listaFixaCampos);

    if (this.embed == null) {
      this.$router.push({
        path: `/admin/app/${this.module}/${this.sid}/flow/${item.id}`
      });
    } else {
      this.embed.params = {
        module: this.module,
        sid: this.sid,
        action: "flow",
        id: item.id
      };
    }
  }

  viewItem(item) {
    this.lista.campos = _.clone(this.listaFixaCampos);
    if (this.embed == null) {
      this.$router.push({
        path: `/admin/app/${this.module}/${this.sid}/view/${item.id}`
      });
    } else {
      this.embed.params = {
        module: this.module,
        sid: this.sid,
        action: "view",
        id: item.id
      };
    }
  }

  cloneItem(item) {
    this.lista.campos = _.clone(this.listaFixaCampos);

    if (this.embed == null) {
      this.$router.push({
        path: `/admin/app/${this.module}/${this.sid}/new/${item.id}`
      });
    } else {
      this.embed.params = {
        module: this.module,
        sid: this.sid,
        action: "new",
        id: item.id
      };
    }
  }

  SAMEPAGEadd(extend = null) {
    this.myself.displayDialogData = {
      tabela: this.module,
      action: "new",
      titulo:
        this.myself.lista.modulo.mod_titulo +
        " - " +
        this.myself.lista.modulo.mod_acao_add,
      sid: this.myself.sid
    };

    if (
      this.myself.localsession[this.myself.sid] &&
      this.myself.localsession[this.myself.sid].joinedfrom != null
    ) {
      this.myself.displayDialogData.jid = this.myself.localsession[
        this.myself.sid
      ].joinedid;
      this.myself.displayDialogData.jtabela = this.myself.localsession[
        this.myself.sid
      ].joinedfrom;
      this.myself.displayDialogData.sid = this.myself.localsession[
        this.myself.sid
      ].joinedsid;
    }

    if (extend) _.extend(this.myself.displayDialogData, extend);
    this.myself.displayDialog = true;
  }

  SAMEPAGEeditItem(item, lang = null, extend = null) {
    this.myself.displayDialogData = {
      tabela: this.module,
      action: "edit",
      id: item.id,
      titulo: this.myself.lista.modulo.mod_titulo + " - " + "Editar",
      sid: this.myself.sid
    };

    if (
      this.myself.localsession[this.myself.sid] &&
      this.myself.localsession[this.myself.sid].joinedfrom != null
    ) {
      this.myself.displayDialogData.jid = this.myself.localsession[
        this.myself.sid
      ].joinedid;
      this.myself.displayDialogData.jtabela = this.myself.localsession[
        this.myself.sid
      ].joinedfrom;
      this.myself.displayDialogData.sid = this.myself.localsession[
        this.myself.sid
      ].joinedsid;
    }
    if (extend) _.extend(this.myself.displayDialogData, extend);

    this.myself.displayDialog = true;
  }

  SAMEPAGEviewItem(item, extend = null) {
    this.myself.displayDialogData = {
      tabela: this.module,
      action: "view",
      id: item.id,
      titulo: this.myself.lista.modulo.mod_titulo + " - " + "Visualizar",
      sid: this.myself.sid
    };
    if (extend) _.extend(this.myself.displayDialogData, extend);

    this.myself.displayDialog = true;
  }

  async deleteItem(item) {
    try {
      let retorno = null;

      retorno = await this.executeFunction(this.lista.modulo.pre_del, [
        item.id,
        item
      ]);
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction(
        "fn.fn_auto_" + this.module + "_pre_del",
        [item.id, item]
      );
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction("this.pre_del", [item.id, item]);
      if (retorno === false) throw new Error("UNDEFINED");

      this.loading = true;

      let clone = _.clone(this.localsession[this.sid]);
      delete clone["filtro"];

      let aposdel = await rest.delete({
        websocket: this.classCrud.getSocketIO(),
        module: this.module,
        id: item.id,
        localsession: clone
      });

      retorno = await this.executeFunction(this.lista.modulo.pos_del, [
        item.id,
        item
      ]);
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction(
        "fn.fn_auto_" + this.module + "_pos_del",
        [item.id, item]
      );
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction("this.pos_del", [item.id, item]);
      if (retorno === false) throw new Error("UNDEFINED");

      this.loading = false;
      this.forceReload();
    } catch (e) {
      //DISPARAR UM ERRO E MOSTRAR!
      this.loading = false;
      this.captureAndDisplayErrorToast(e);
    }
  }

  async forceReload() {
    this.oldHash = null;
    await this.loadAll();
  }

  async carregaTudoJson() {
    //busca json all

    this.loadingIntra = true;

    let clone = _.clone(this.localsession[this.sid]);
    delete clone["filtro"];

    let filtromap = {};
    for (let no of this.configcruds[this.module].filtrosShow) {
      filtromap[no.cmp_coluna] = this.localsession[this.sid].filtro[
        no.cmp_coluna
      ];
    }

    let pact = _.clone(this.paginationActive);
    pact.porPagina = -1;
    pact.exportmode = true;

    let apos = await rest.loadAll({
      websocket: this.classCrud.getSocketIO(),
      module: this.module,
      localsession: clone,
      filtro: filtromap,
      pagination: pact
    });
    this.loadingIntra = false;
    let map = apos.data.resultset;
    //console.log(map);

    let all = [];

    let tabelaorig = this.module;
    if (tabelaorig.indexOf("_v_") != -1)
      tabelaorig = tabelaorig.split("_v_")[0];

    for (let mapi of map) {
      let allo = [];
      for (let no of this.headers) {
        if (
          no.campo.cmp_tipo == "join" &&
          mapi[
            "_join_" +
              no.campo.cmp_coluna +
              "_" +
              tabelaorig +
              "_" +
              no.campo.cmp_join_tabela
          ]
        ) {
          allo.push(
            mapi[
              "_join_" +
                no.campo.cmp_coluna +
                "_" +
                tabelaorig +
                "_" +
                no.campo.cmp_join_tabela
            ]._joined
          );
        } else allo.push(mapi[no.campo.cmp_coluna]);
      }
      all.push(allo);
    }

    return all;

    //return false;
  }

  async gerarExcel($refs, all = null) {
    if (all != null) {
      //busca json all
      all = await this.carregaTudoJson();
      //console.log(all);
      //return false;
    }

    let tabela = $refs.datatableObj[0].$el.children[0].children[0];
    let headersOfTable = this.headers.map(v => v.text);
    Export2Multi.export_table_to_excel(
      null,
      tabela,
      headersOfTable,
      this.lista.modulo.mod_titulo,
      all
    );
  }

  async gerarCSV($refs, all = null) {
    if (all != null) {
      //busca json all
      all = await this.carregaTudoJson();
      //console.log(all);
      //return false;
    }

    let tabela = $refs.datatableObj[0].$el.children[0].children[0];
    let headersOfTable = this.headers.map(v => v.text);
    Export2Multi.export_table_to_csv(
      null,
      tabela,
      headersOfTable,
      this.lista.modulo.mod_titulo,
      all
    );
  }

  async gerarJSON($refs, all = null) {
    if (all != null) {
      //busca json all
      all = await this.carregaTudoJson();
      //console.log(all);
      //return false;
    }

    let tabela = $refs.datatableObj[0].$el.children[0].children[0];
    let headersOfTable = this.headers.map(v => v.text);
    Export2Multi.export_table_to_json(
      null,
      tabela,
      headersOfTable,
      this.lista.modulo.mod_titulo,
      all
    );
  }
  async gerarPDF($refs, all = null) {
    if (all != null) {
      //busca json all
      all = await this.carregaTudoJson();
      //console.log(all);
      //return false;
    }

    let tabela = $refs.datatableObj[0].$el.children[0].children[0];
    let headersOfTable = this.headers.map(v => v.text);
    Export2Multi.export_table_to_pdf(
      null,
      tabela,
      headersOfTable,
      this.lista.modulo.mod_titulo,
      all
    );
  }
  gerarPrint() {
    window.print();
  }

  async loadAll() {
    this.newHash = JSON.stringify(this.paginationActive);

    if (this.newHash != this.oldHash) {
      this.oldHash = this.newHash;
    } else {
      return;
    }

    this.resetScope();

    let filtromap = {};
    for (let no of this.configcruds[this.module].filtrosShow) {
      filtromap[no.cmp_coluna] = this.localsession[this.sid].filtro[
        no.cmp_coluna
      ];
    }
    try {
      let clone = _.clone(this.localsession[this.sid]);
      delete clone["filtro"];

      let retorno = null;

      retorno = await this.executeFunction(this.lista.modulo.pre_list, [
        clone,
        filtromap
      ]);
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction(
        "fn.fn_auto_" + this.module + "_pre_list",
        [clone, filtromap]
      );
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction("this.pre_list", [clone, filtromap]);
      if (retorno === false) throw new Error("UNDEFINED");
      this.loadingIntra = true;

      let apos = await rest.loadAll({
        websocket: this.classCrud.getSocketIO(),
        module: this.module,
        localsession: clone,
        filtro: filtromap,
        pagination: this.paginationActive
      });

      let preEXTRA = this.metadata._extra;
      if (apos.data.metadata._extra == null && preEXTRA != null) {
        apos.data.metadata._extra = preEXTRA;
      }

      this.metadata = apos.data.metadata || {};

      if (this.metadata.lista != null) {
        this.lista = this.metadata.lista;
      }

      if (apos.data.metadata.ordecol) {
        this.configcruds[this.module].orderCols = apos.data.metadata.ordecol;
        //REORDENAR OS CAMPOS.]

        let oc = this.configcruds[this.module].orderCols;
        /*
        this.lista.campos.sort((a, b) => {
          return oc.indexOf(a.cmp_coluna) - oc.indexOf(b.cmp_coluna);
        });
        */
        this._fillDataTable();
      }

      if (apos.data.metadata) {
        if (apos.data.metadata.colunas) {
          for (let col in apos.data.metadata.colunas) {
            this.configcruds[this.module].displayCols[col] =
              apos.data.metadata.colunas[col];
          }
          this._fillDataTable();
        } else if (
          this.configcruds[this.module].displayCols == null ||
          Object.keys(this.configcruds[this.module].displayCols).length == 0
        ) {
          this.configcruds[this.module].displayCols = {};
          for (let campo of this.lista.campos) {
            //TODO
            if (
              campo.cmp_lista == true &&
              (apos.data.metadata._skip == null ||
                apos.data.metadata._skip[campo.cmp_coluna] != true)
            ) {
              this.configcruds[this.module].displayCols[campo.cmp_coluna] = 1;
            }
          }
        }

        if (apos.data.metadata.filtros) {
          this.configcruds[this.module].filtrohide = [];
          for (let col of apos.data.metadata.filtros) {
            let campo = this.lista.campos.filter(v => v.cmp_coluna == col);
            if (campo.length > 0) campo = campo[0];
            this.hideFiltro(campo, true);
          }
        }
        if (apos.data.metadata._extra)
          this.metadataextra = apos.data.metadata._extra;
      }

      this.localsession[this.sid].primeiroSid = false;

      let resultset = apos.data.resultset;

      retorno = await this.executeFunction(this.lista.modulo.antes, [
        resultset
      ]);
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction(
        "fn.fn_auto_" + this.module + "_antes",
        [resultset]
      );
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction("this.antes", [resultset]);
      if (retorno === false) throw new Error("UNDEFINED");
      for (let i in resultset) {
        resultset[i].__deleting = false;
        retorno = await this.executeFunction(this.lista.modulo.aomeio, [
          resultset[i]
        ]);
        if (retorno === false) throw new Error("UNDEFINED");
        retorno = await this.executeFunction(
          "fn.fn_auto_" + this.module + "_aomeio",
          [resultset[i]]
        );
        if (retorno === false) throw new Error("UNDEFINED");
        retorno = await this.executeFunction("this.aomeio", [resultset[i]]);
        if (retorno === false) throw new Error("UNDEFINED");
      }
      retorno = await this.executeFunction(this.lista.modulo.final, [
        resultset
      ]);
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction(
        "fn.fn_auto_" + this.module + "_final",
        [resultset]
      );
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction("this.final", [resultset]);
      if (retorno === false) throw new Error("UNDEFINED");

      /***NAO FAZER ISSO NO MODULO e SIM NO COMPONENTE
            for (let campo of this.lista.campos) {
              if (!campo.cmp_lista || campo.cmp_conta == null || campo.cmp_conta == '') continue;
              //aplica funcao conta.
              for (let i in resultset) {
                resultset[i][campo.cmp_coluna] = await this.executeFunction(campo.cmp_conta, [resultset[i][campo.cmp_coluna], resultset[i]]);
              }
            }
       */
      retorno = await this.executeFunction(this.lista.modulo.pos_list, [
        resultset
      ]);
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction(
        "fn.fn_auto_" + this.module + "_pos_list",
        [resultset]
      );
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction("this.pos_list", [resultset]);
      if (retorno === false) throw new Error("UNDEFINED");

      if (this.paginationActive.lazyloadpage) {
        this.resultset.push(...resultset);
        delete this.paginationActive.lazyloadpage;
      } else {
        this.resultset = resultset;
      }

      this.totalItems = apos.data.total;
      this.loading = false;
      this.loadingIntra = false;

      this.selected = [];

      /**Aplicar ordenacao se houver */

      const temOrdenacao =
        this.lista.campos.filter(c => c.cmp_coluna == "order_by").length == 1;
      if (temOrdenacao) {
        this.lista.campos.map(c => {
          c.cmp_ordem = false;
          return c;
        });

        /***SOMENTE SE NAO FILTROU */
        let temFiltro = false;
        for (let ko in this.localsession[this.sid].filtro) {
          if (
            this.localsession[this.sid].filtro[ko] !== null &&
            this.localsession[this.sid].filtro[ko] !== ""
          ) {
            temFiltro = true;
            break;
          }
        }

        if (!temFiltro) {
          this.addOrdenacao();
        }
      }

      this._fillDataTable();
    } catch (e) {
      this.loading = false;
      this.loadingIntra = false;
      this.captureAndDisplayError(e);
    }
  }

  captureAndDisplayError(e) {
    this.loading = false;
    if (e.response != null) {
      //erro disparado back-end
      this.errorMsg = e.response.data.error;

      if (
        this.errorMsg != null &&
        this.errorMsg.indexOf("you do not have access to this resource") != -1
      ) {
        setTimeout(() => {
          this.$store.dispatch("setToken", null);
          this.$store.dispatch("setUser", null);
          window.location =
            window.location.href.split("#")[0] + "#/admin/login";
        }, 2000);
      }
      if (e.response) window.lastErrorStack = e.response.data.stack;
      else window.lastErrorStack = null;
    } else if (!!e.message) {
      //erro disparado front-end
      this.errorMsg = e.message;
      if (e.response) window.lastErrorStack = e.response.data.stack;
      else window.lastErrorStack = null;
    }
  }

  captureAndDisplayErrorToast(e) {
    this.loading = false;
    if (e.response != null) {
      //erro disparado back-end

      let toast = this.$toasted.error(e.response.data.error, {
        position: "top-center",
        duration: 5000,
        keepOnHover: true
      });
    } else if (!!e.message) {
      //erro disparado front-end
      let toast = this.$toasted.error(e.message, {
        position: "top-center",
        duration: 5000,
        keepOnHover: true
      });
    }
  }

  async loadZero(id, clone = null, formprevio = null) {
    //form add
    this.errorMsg = null;

    try {
      let retorno = null;

      retorno = await this.executeFunction(this.lista.modulo.pre_add, [
        null,
        null
      ]);
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction(
        "fn.fn_auto_" + this.module + "_pre_add",
        [null, null]
      );
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction("this.pre_add", [null, null]);
      if (retorno === false) throw new Error("UNDEFINED");

      this.loading = true;

      let clone = _.clone(this.localsession[this.sid]);
      delete clone["filtro"];

      let apos = await rest.loadZero({
        websocket: this.classCrud.getSocketIO(),
        module: this.module,
        localsession: clone
      });

      this.form = apos.data.obj;
      if (formprevio) {
        for (let x in formprevio) {
          this.form[x] = formprevio[x];
        }
      }

      this.metadata = apos.data.metadata || {};
      if (this.metadata.lista != null) {
        this.lista = this.metadata.lista;
      }

      for (let campo of this.lista.campos) {
        if (
          !campo.cmp_add ||
          (this.metadata._skip != null &&
            this.metadata._skip[campo.cmp_coluna] === true)
        )
          continue;

        //VALOR DEFAULT
        let temdef = this.canExecuteFunction(campo.valorpadrao);
        if (temdef) {
          let valdef = await this.executeFunction(campo.valorpadrao, [
            campo.cmp_coluna
          ]);
          if (valdef !== null) {
            this.form[campo.cmp_coluna] = valdef;
          }
        } else if (
          campo.valorpadrao !== null &&
          campo.valorpadrao !== "" &&
          (this.form[campo.cmp_coluna] === null ||
            this.form[campo.cmp_coluna] === undefined)
        ) {
          this.form[campo.cmp_coluna] = campo.valorpadrao;
        } else {
        }
      }

      retorno = await this.executeFunction(this.lista.modulo.pos_add, [
        null,
        this.form
      ]);
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction(
        "fn.fn_auto_" + this.module + "_pos_add",
        [null, this.form]
      );
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction("this.pos_add", [null, this.form]);
      if (retorno === false) throw new Error("UNDEFINED");

      this.loading = false;
    } catch (e) {
      this.loading = false;
      this.captureAndDisplayError(e);
    }
  }

  async loadOne(id, clone = null) {
    //edit
    this.errorMsg = null;
    try {
      let retorno = null;

      retorno = await this.executeFunction(this.lista.modulo.pre_edit, [
        id,
        null
      ]);
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction(
        "fn.fn_auto_" + this.module + "_pre_edit",
        [id, null]
      );
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction("this.pre_edit", [id, null]);
      if (retorno === false) throw new Error("UNDEFINED");

      this.loading = true;

      let clone = _.clone(this.localsession[this.sid]);
      delete clone["filtro"];

      let routemap = this.embed != null ? this.embed : this.$store.state.route;

      if (routemap.query != null && routemap.query.lang != null) {
        clone.langedit = routemap.query.lang;
      }

      let apos = await rest.loadOne({
        websocket: this.classCrud.getSocketIO(),
        module: this.module,
        id: id,
        action: this.action,
        localsession: clone
      });
      this.form = apos.data.obj;

      if (clone != null) {
        this.form._clone_id = id;

        delete this.form.id;
        delete this.form.pes_id;
      }
      this.metadata = apos.data.metadata || {};

      if (this.metadata.lista != null) {
        this.lista = this.metadata.lista;
      }

      retorno = await this.executeFunction(this.lista.modulo.pos_edit, [
        id,
        this.form
      ]);
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction(
        "fn.fn_auto_" + this.module + "_pos_edit",
        [id, this.form]
      );
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction("this.pos_edit", [id, this.form]);
      if (retorno === false) throw new Error("UNDEFINED");

      this.loading = false;

      //console.log(this.metadata);
    } catch (e) {
      this.loading = false;
      this.captureAndDisplayError(e);
    }
  }

  async loadOneView(id) {
    //view

    this.errorMsg = null;

    try {
      let retorno = null;

      retorno = await this.executeFunction(this.lista.modulo.pre_view, [
        id,
        null
      ]);
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction(
        "fn.fn_auto_" + this.module + "_pre_view",
        [id, null]
      );
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction("this.pre_view", [id, null]);
      if (retorno === false) throw new Error("UNDEFINED");
      this.loading = true;

      let clone = _.clone(this.localsession[this.sid]);
      delete clone["filtro"];

      let apos = await rest.loadOneView({
        websocket: this.classCrud.getSocketIO(),
        module: this.module,
        id: id,
        localsession: clone
      });
      this.form = apos.data.obj;
      this.metadata = apos.data.metadata || {};
      if (this.metadata.lista != null) {
        this.lista = this.metadata.lista;
      }

      for (let campo of this.lista.campos) {
        if (
          !campo.cmp_lista ||
          campo.cmp_conta == null ||
          campo.cmp_conta == ""
        )
          continue;
        //aplica funcao conta.
        this.form[
          campo.cmp_coluna
        ] = await this.executeFunction(campo.cmp_conta, [
          this.form[campo.cmp_coluna],
          this.form
        ]);
      }

      retorno = await this.executeFunction(this.lista.modulo.pos_view, [
        id,
        this.form
      ]);
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction(
        "fn.fn_auto_" + this.module + "_pos_view",
        [id, this.form]
      );
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction("this.pos_view", [id, this.form]);
      if (retorno === false) throw new Error("UNDEFINED");

      this.loading = false;
    } catch (e) {
      this.loading = false;
      this.captureAndDisplayError(e);
    }
  }

  add() {
    this.lista.campos = _.clone(this.listaFixaCampos);

    if (this.embed == null) {
      this.$router.push({
        path: `/admin/app/${this.module}/${this.sid}/new`
      });
    } else {
      this.embed.params = {
        module: this.module,
        sid: this.sid,
        action: "new"
      };
    }
  }

  async save_add() {
    try {
      let retorno = null;

      await this.validationOnSave();

      retorno = await this.executeFunction(this.lista.modulo.pre_insert, [
        null,
        this.form
      ]);
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction(
        "fn.fn_auto_" + this.module + "_pre_insert",
        [null, this.form]
      );
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction("this.pre_insert", [
        null,
        this.form
      ]);
      if (retorno === false) throw new Error("UNDEFINED");

      this.loading = true;

      let clone = _.clone(this.localsession[this.sid]);
      delete clone["filtro"];

      let apos = await rest.insert({
        websocket: this.classCrud.getSocketIO(),
        module: this.module,
        form: global.fn.metadmin_clean_form_extras(this.form),
        localsession: clone
      });

      retorno = await this.executeFunction(this.lista.modulo.pos_insert, [
        apos.data.obj.id,
        this.form
      ]);
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction(
        "fn.fn_auto_" + this.module + "_pos_insert",
        [apos.data.obj.id, this.form]
      );
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction("this.pos_insert", [
        apos.data.obj.id,
        this.form
      ]);
      if (retorno === false) throw new Error("UNDEFINED");
      this.loading = false;

      if (this.ignoreRedirect) {
        this.ignoreRedirect = false;
        return;
      }

      if (this.myself.returnfn != null) {
        this.myself.returnfn(apos.data.obj);
        return;
      }

      if (this.embed == null) {
        this.$router.push({
          path: `/admin/app/${this.module}/${this.sid}/list`
        });
      } else {
        this.embed.params = {
          module: this.module,
          sid: this.sid,
          action: "list"
        };
      }
    } catch (e) {
      this.loading = false;
      this.captureAndDisplayError(e);
    }
  }

  async validationOnSave() {
    if (this.classCrud.validationMeta != null) {
      let rules = this.classCrud.validationMeta["*"];
      if (rules != null && Array.isArray(rules)) {
        let errorList = [];
        for (let r of rules) {
          let re = r.apply(this, [this.form]);
          if (re !== true) {
            errorList.push(re);
          }
        }
        if (errorList.length > 0) {
          throw new Error(errorList.join("<br/>"));
        }
      }
    }
  }

  async save_edit(flowact = null) {
    try {
      let routemap = this.embed != null ? this.embed : this.$store.state.route;

      let retorno = null;

      await this.validationOnSave();

      retorno = await this.executeFunction(this.lista.modulo.pre_update, [
        routemap.params.id,
        this.form
      ]);
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction(
        "fn.fn_auto_" + this.module + "_pre_update",
        [routemap.params.id, this.form]
      );
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction("this.pre_update", [
        routemap.params.id,
        this.form
      ]);
      if (retorno === false) throw new Error("UNDEFINED");

      this.loading = true;

      let clone = _.clone(this.localsession[this.sid]);
      delete clone["filtro"];

      let pack = {
        websocket: this.classCrud.getSocketIO(),
        module: this.module,
        form: global.fn.metadmin_clean_form_extras(this.form),
        flowact: flowact,
        id: routemap.params.id,
        localsession: clone
      };

      if (routemap.query != null && routemap.query.lang != null) {
        pack.langedit = routemap.query.lang;
      }

      let apos = await rest.update(pack);

      retorno = await this.executeFunction(this.lista.modulo.pos_update, [
        routemap.params.id,
        this.form
      ]);
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction(
        "fn.fn_auto_" + this.module + "_pos_update",
        [routemap.params.id, this.form]
      );
      if (retorno === false) throw new Error("UNDEFINED");
      retorno = await this.executeFunction("this.pos_update", [
        routemap.params.id,
        this.form
      ]);
      if (retorno === false) throw new Error("UNDEFINED");
      this.loading = false;
      if (this.ignoreRedirect) {
        this.ignoreRedirect = false;
        return;
      }

      if (this.myself.returnfn != null) {
        this.myself.returnfn(this.form);
        return;
      }

      if (this.embed == null) {
        this.$router.push({
          path: `/admin/app/${this.module}/${this.sid}/list`
        });
      } else {
        this.embed.params = {
          module: this.module,
          sid: this.sid,
          action: "list"
        };
      }
    } catch (e) {
      this.loading = false;
      this.captureAndDisplayError(e);
    }
  }

  async executeFunction(functionName, args) {
    if (typeof functionName == "function") {
      let fninstance = functionName;
      if (fninstance != null) {
        if (fninstance.constructor.name === "AsyncFunction")
          return await fninstance.apply(this, args);
        else return fninstance.apply(this, args);
      }
    }

    if (functionName != null && functionName.trim().substr(0, 3) == "fn.") {
      let fnname = functionName
        .trim()
        .substr(3)
        .trim();
      let fninstance = global.fn[fnname];
      if (fninstance != null) {
        if (fninstance.constructor.name === "AsyncFunction")
          return await fninstance.apply(this, args);
        else return fninstance.apply(this, args);
      }
    }

    if (functionName != null && functionName.trim().substr(0, 5) == "this.") {
      let fnname = functionName
        .trim()
        .substr(5)
        .trim();
      let fninstance = this.classCrud[fnname];

      if (fninstance != null) {
        if (fninstance.constructor.name === "AsyncFunction")
          return await fninstance.apply(this.classCrud, args);
        else return fninstance.apply(this.classCrud, args);
      }
    }

    if (
      functionName != null &&
      ((functionName.trim().substr(0, 1) == "(" &&
        functionName.indexOf("=>") != -1) ||
        (functionName.trim().substr(0, 7) == "async (" &&
          functionName.indexOf("=>") != -1) ||
        functionName.trim().substr(0, 9) == "function(" ||
        functionName.trim().substr(0, 15) == "async function(")
    ) {
      let fninstance = eval(functionName.trim());
      if (fninstance != null) {
        if (fninstance.constructor.name === "AsyncFunction")
          return await fninstance.apply(this, args);
        else return fninstance.apply(this, args);
      }
    }

    return null;
  }

  executeFunctionSync(functionName, args) {
    if (typeof functionName == "function") {
      return fninstance.apply(this, args);
    }
    if (functionName != null && functionName.trim().substr(0, 3) == "fn.") {
      let fnname = functionName
        .trim()
        .substr(3)
        .trim();
      let fninstance = global.fn[fnname];
      if (fninstance != null) {
        return fninstance.apply(this, args);
      }
    }

    if (functionName != null && functionName.trim().substr(0, 5) == "this.") {
      let fnname = functionName
        .trim()
        .substr(5)
        .trim();
      let fninstance = this.classCrud[fnname];

      if (fninstance != null) {
        return fninstance.apply(this.classCrud, args);
      }
    }

    if (
      functionName != null &&
      ((functionName.trim().substr(0, 1) == "(" &&
        functionName.indexOf("=>") != -1) ||
        (functionName.trim().substr(0, 7) == "async (" &&
          functionName.indexOf("=>") != -1) ||
        functionName.trim().substr(0, 9) == "function(" ||
        functionName.trim().substr(0, 15) == "async function(")
    ) {
      let fninstance = eval(functionName.trim());
      if (fninstance != null) {
        return fninstance.apply(this, args);
      }
    }

    return null;
  }

  canExecuteFunction(functionName, args) {
    if (functionName != null) functionName = functionName + "";

    if (typeof functionName == "function") {
      return true;
    } else if (
      functionName != null &&
      functionName.trim().substr(0, 3) == "fn." &&
      global.fn[functionName.trim().substr(3)] != null
    ) {
      return true;
    } else if (
      functionName != null &&
      functionName.trim().substr(0, 5) == "this." &&
      this[functionName.trim().substr(5)] != null
    ) {
      return true;
    } else if (
      functionName != null &&
      ((functionName.trim().substr(0, 1) == "(" &&
        functionName.indexOf("=>") != -1) ||
        (functionName.trim().substr(0, 7) == "async (" &&
          functionName.indexOf("=>") != -1) ||
        functionName.trim().substr(0, 9) == "function(" ||
        functionName.trim().substr(0, 15) == "async function(")
    ) {
      return true;
    }
    return false;
  }

  dataParam(key) {
    if (this.localsession[this.sid].data != null)
      return this.localsession[this.sid].data[key];
    return null;
  }

  avaliaPermissao(acao, obj) {
    if (acao == "flow" && obj._extra && obj._extra.skip_flow === true)
      return false;
    if (acao == "edit" && obj._extra && obj._extra.skip_edit === true)
      return false;
    if (acao == "del" && obj._extra && obj._extra.skip_del === true)
      return false;
    if (acao == "view" && obj._extra && obj._extra.skip_view === true)
      return false;

    if (
      acao == "add" &&
      (this.lista.modulo.mod_acao_add == null ||
        this.lista.modulo.mod_acao_add == "" ||
        this.lista.modulo.mod_acao_add == false)
    )
      return false;
    if (acao == "flow" && this.lista.modulo.mod_acao_edit == false)
      return false;
    if (acao == "edit" && this.lista.modulo.mod_acao_edit == false)
      return false;
    if (acao == "view" && this.lista.modulo.mod_acao_view == false)
      return false;
    if (acao == "del" && this.lista.modulo.mod_acao_del == false) return false;

    if (!global.features.perm_can_do("|" + this.module, acao)) return false;
    return true;
  }

  _toggleAll() {
    if (this.selected.length) this.selected = [];
    else this.selected = this.resultset.slice();
  }
  _changeSort(header) {
    const column = header.value;

    if (header.sortable === false) return;

    if (this.paginationActive.sortBy === column) {
      this.paginationActive.descending = !this.paginationActive.descending;
    } else {
      this.paginationActive.sortBy = column;
      this.paginationActive.descending = false;
    }
  }

  _formSubmit(form, flowact = null) {
    if (form.validate()) {
      if (this.action == "new") this.save_add();
      if (this.action == "edit") this.save_edit();
      if (this.action == "flow") this.save_edit(flowact);
    }
  }
  _formClear(form) {
    form.reset();
  }

  _goBack() {
    if (this.myself.backfn != null) {
      this.myself.backfn();
      return;
    }

    if (this.embed == null) this.$router.go(-1);
    else
      this.embed.params = {
        module: this.module,
        sid: this.sid,
        action: "list"
      };
  }

  evaluatedCustom(custom, id, row) {
    let ret = {
      name: null,
      action: null,
      html: null
    };
    let arrow = null;

    let functionName = custom.cus_exibe;
    if (functionName != null && functionName.trim().substr(0, 3) == "fn.") {
      arrow = global.fn[functionName.trim().substr(3)];
    } else if (
      functionName != null &&
      functionName.trim().substr(0, 5) == "this."
    ) {
      arrow = this.classCrud[functionName.trim().substr(5)];
    } else if (functionName != null && functionName != "") {
      arrow = eval(custom.cus_exibe);
    }
    let arrowed = null;
    if (arrow) arrowed = arrow.bind(this)(id, row);
    if (arrowed) {
      ret.name = arrowed.name(id, row);
      ret.action = arrowed.action;
      ret.html = arrowed.html(id, row);
    }
    return ret;
  }

  returnFromJoin(joinpack) {
    if (this.embed == null) {
      this.$router.replace({
        path:
          "/admin/app/" +
          joinpack.joinedfrom +
          "/" +
          joinpack.joinedsid +
          "/list"
      });
    } else {
      this.embed.params = {
        module: joinpack.joinedfrom,
        sid: joinpack.joinedsid,
        action: "list"
      };
      this.embed.query = null;
    }
  }

  navigateToModule(name, query = null) {
    //console.log(name);
    if (this.embed == null) {
      this.$router.push({
        path: `/admin/app/${name}`,
        query
      });
    } else {
      this.embed = {
        params: {
          module: name
        },
        query: query
      };
    }
  }

  callAction(actionName, id, extra = {}, callback = null, callbacke = null) {
    let clone = _.clone(this.localsession[this.sid]);
    delete clone["filtro"];

    let credentials = {
      module: this.module,
      actionName: actionName,
      id: id,
      extra: extra,
      localsession: clone
    };
    Api()
      .post("admin/crud/action", credentials)
      .then(callback)
      .catch(callbacke)
      .finally(() => {
        this.loading = false;
        this.loadingIntra = false;
      });
  }

  callFlowAction(actionName, id) {
    let clone = _.clone(this.localsession[this.sid]);
    delete clone["filtro"];

    let credentials = {
      module: this.module,
      actionName: actionName,
      id: id,
      localsession: clone
    };
    Api()
      .post("admin/crud/flowAction", credentials)
      .then(res => {
        let result = res.data;
        this.displayAlertBox("Executado com sucesso!");
        this.forceReload();
      })
      .catch(err => {
        this.displayErrorBox(err.response.data.error);
        console.log("error", err);
      })
      .finally(() => {
        this.loading = false;
        this.loadingIntra = false;
      });
  }

  filtrar() {
    if (this.myself.configprops.list === false) {
      this.$router.push({
        path: `/admin/app/${this.module}`,
        query: {
          filtro: this.localsession[this.sid].filtro
        }
      });
      return;
    }
    this.oldHash = null;
    this.loadAll();
  }

  pertenceAListaK(coluna, lista = []) {
    let has = false;
    for (let no of lista) {
      if (no.k == coluna) {
        has = true;
        break;
      }
    }
    return has;
  }

  hideFiltro(campo, automatic = null) {
    this.configcruds[this.module].filtrohide.push({
      k: campo.cmp_coluna,
      v: campo.cmp_titulo
    });
    this.localsession[this.sid].filtro[campo.cmp_coluna] = null;

    this.filtrosShowUpdate();

    if (automatic == null) this.saveFiltrosAndCols();
  }

  addFiltro() {
    let qual = this.configcruds[this.module].filtrosel;
    for (let noi in this.configcruds[this.module].filtrohide) {
      let no = this.configcruds[this.module].filtrohide[noi];
      if (no.k == qual) {
        this.configcruds[this.module].filtrohide.splice(noi, 1);
      }
    }
    this.configcruds[this.module].filtrosel = null;
    this.filtrosShowUpdate();
    this.saveFiltrosAndCols();
  }

  filtrosShowUpdate() {
    let fs = [];
    for (let campo of this.lista.campos) {
      if (
        campo.cmp_filtro &&
        (this.metadata._skipfiltro == null ||
          this.metadata._skipfiltro[campo.cmp_coluna] !== true)
      ) {
        if (
          campo.cmp_filtro &&
          !this.pertenceAListaK(
            campo.cmp_coluna,
            this.configcruds[this.module].filtrohide
          )
        ) {
          fs.push(campo);
        }
      }
    }

    //filtrosManuais
    let meusf = global.reqClass.filtro_client.filter(
      v => v.indexOf(this.module + "-") === 0
    );
    for (let fi of meusf) {
      let info = fi.split("-");
      if (
        !this.pertenceAListaK(
          "fmix_" + info[1],
          this.configcruds[this.module].filtrohide
        )
      ) {
        fs.push({
          cmp_filtro: true,
          cmp_coluna: "fmix_" + info[1],
          cmp_titulo: global.appmap_auto.filtro_client_alias[fi] || info[1],
          cmp_tipo: "filtro" + fi
        });
      }
    }

    this.configcruds[this.module].filtrosShow = fs;

    Vue.set(this, "localsession", _.clone(this.localsession));
    Vue.set(this, "configcruds", _.clone(this.configcruds));
  }

  colsShowUpdate() {
    if (Object.keys(this.configcruds[this.module].displayCols).length <= 0)
      return;

    let fs = {};
    for (let campo of this.lista.campos) {
      if (campo.cmp_lista) {
        fs[campo.cmp_coluna] = 1;
      }
    }

    this.configcruds[this.module].displayCols = fs;

    Vue.set(this, "localsession", _.clone(this.localsession));
    this.$forceUpdate();
  }

  gerenciarCampos() {
    this.gerenciarDialog = !this.gerenciarDialog;
  }

  syncStoreSession() {
    this.$store.dispatch("setSession", this.localsession);
  }

  evalrules(campo) {
    let titulo = campo.cmp_titulo;
    let v = campo.cmp_valida;
    if (v == null || v == "") v = [true];

    // console.log(
    //   "VTT",
    //   campo.cmp_titulo,
    //   this,
    //   this.campoRef[campo.cmp_coluna]
    // );
    let ev = eval(v);
    if (
      this.campoRef &&
      this.campoRef[campo.cmp_coluna] &&
      this.campoRef[campo.cmp_coluna].validationRule
    ) {
      // console.log("VTT");
      let outra = this.campoRef[campo.cmp_coluna].validationRule();
      if (outra !== null && outra !== undefined) ev.push(outra);
    }
    if (
      this.classCrud.validationMeta != null &&
      this.classCrud.validationMeta[campo.cmp_coluna] != null
    ) {
      let outras = this.classCrud.validationMeta[campo.cmp_coluna];
      if (!Array.isArray(outras)) outras = [outras];
      for (let o of outras) {
        ev.push(o);
      }
    }

    return ev;
  }

  displayErrorBox(msg) {
    this.errorBox = {
      display: true,
      text: msg
    };
  }
  displayAlertBox(msg) {
    this.alertBox = {
      display: true,
      text: msg
    };
  }

  resetScope() {
    console.log("RESET SCOPE");
    this.errorMsg = null;
    this.metadata = {};
    this.abasmodel = 0;
    this.optionsDrag = null;
  }

  setConfigProps() {
    let modProps = {};
    try {
      modProps = JSON.parse(this.lista.modulo.mod_lojson);
      if (modProps == null) modProps = {};
    } catch (e) {
      modProps = {};
    }
    _.assignIn(this.configprops, modProps);
    if (this.embed != null && this.embed.props != null)
      _.assignIn(this.configprops, this.embed.props);
  }

  _fillDataTable(colchanged = null) {
    this.headers = [];
    for (let campo of this.lista.campos) {
      if (campo.cmp_lista == true) {
        if (
          this.metadata._skip != null &&
          this.metadata._skip[campo.cmp_coluna] === true
        )
          continue;

        if (this.configcruds[this.module].displayCols[campo.cmp_coluna] == 1) {
          this.headers.push({
            text: campo.cmp_titulo,
            align: "left",
            value: campo.cmp_coluna,
            campo: campo,
            sortable: campo.cmp_ordem
          });
        }
      }
    }

    if (
      this.localsession[this.sid].group_list != null &&
      this.localsession[this.sid].group_list.length > 0
    ) {
      this.headers.push({
        text: "Quantidade",
        align: "left",
        value: "group_n",
        campo: {
          cmp_coluna: "group_n",
          cmp_titulo: "Quantidade",
          cmp_tipo: "text"
        },
        sortable: false
      });
    }

    if (this.$store.state.config) {
      if (
        this.$store.state.config[
          "COL_SORT_" + this.myself.lista.modulo.mod_tabela
        ]
      ) {
        let pesos = this.$store.state.config[
          "COL_SORT_" + this.myself.lista.modulo.mod_tabela
        ];
        this.headers.sort((a, b) => {
          if (pesos[a.value] * 1 > pesos[b.value] * 1) return 1;
          if (pesos[a.value] * 1 < pesos[b.value] * 1) return -1;
          return 0;
        });
      }
    }

    Vue.set(this, "headers", _.clone(this.headers));
    this.$forceUpdate();
  }

  async toggleGroup(header) {
    let indg = this.myself.localsession[this.myself.sid].group_list.indexOf(
      header.campo.cmp_coluna
    );
    if (indg == -1) {
      this.myself.localsession[this.myself.sid].group_list.push(
        header.campo.cmp_coluna
      );
    } else {
      this.myself.localsession[this.myself.sid].group_list.splice(indg, 1);
    }
    this.oldHash = null;
    await this.loadAll();
  }

  hasGroup(header) {
    let indg = this.myself.localsession[this.myself.sid].group_list.indexOf(
      header.campo.cmp_coluna
    );
    return indg == -1 ? false : true;
  }
  async mounted() {}
  async updated() {}

  async startLoadCrud(forced = null) {
    let routemap;
    if (this.embed != null) {
      routemap = this.embed;
    } else {
      routemap = this.$store.state.route;
    }

    this.configprops = {
      //propriedade default do modulo (o que mostra ou nao)
      filtro: true,
      gc: true,
      titulo: true,
      rodape: true,
      paginacao: true,
      select: true,
      acoes: true,
      colsort: true,
      exportscreen: "pecji",
      exportserver: false
    };

    this.setConfigProps();

    this.pageloaded = this.lista.modulo.classe;

    if (this.paginationActive.sid != this.sid) {
      this.localsession[this.sid].primeiroSid = true;

      if (this.myself.configprops.list === false) {
        this.localsession[this.sid].skip_resultset = true;
      }

      let deford = this.lista.campos.filter(
        c => c.cmp_ordena != null && c.cmp_ordena != ""
      );
      let desc = false;
      let sortBy = null;
      if (deford.length > 0) {
        sortBy = deford[0].cmp_coluna;
        desc = deford[0].cmp_ordena == "DESC" ? true : false;
      }

      const temOrdenacao =
        this.lista.campos.filter(c => c.cmp_coluna == "order_by").length == 1;
      if (temOrdenacao) {
        this.lista.modulo.mod_paginacao = 100000;
      }

      this.paginationActive = {
        descending: desc,
        page: 1,
        rowsPerPage: this.lista.modulo.mod_paginacao
          ? this.lista.modulo.mod_paginacao * 1
          : 20,
        sortBy: sortBy,
        module: this.module,
        sid: this.sid,
        totalItems: 0
      };
    }

    this.filtrosShowUpdate();
    this.colsShowUpdate();

    this.form = null;
    if (this.action == "new") {
      if (routemap.params.id != null) {
        await this.loadOne(routemap.params.id, "clone");
      } else {
        await this.loadZero();
      }
      this.abas = this._trataTpl(
        this.lista.modulo.tplparam,
        this.lista.campos,
        this.action
      );
    }

    if (this.action == "edit") {
      await this.loadOne(routemap.params.id);
      this.abas = this._trataTpl(
        this.lista.modulo.tplparam,
        this.lista.campos,
        this.action
      );
    }
    if (this.action == "flow") {
      await this.loadOne(routemap.params.id);
      this.abas = this._trataTpl(
        this.lista.modulo.tplparam,
        this.lista.campos,
        this.action
      );
    }

    if (this.action == "view") {
      await this.loadOneView(routemap.params.id);
      this.abas = this._trataTpl(
        this.lista.modulo.tplparam,
        this.lista.campos,
        this.action
      );
    }

    if (this.action == "list" || forced == true) {
      //this.oldHash = null;
      await this.loadAll();
    }
  }

  alterouPaginacao(old, newv) {
    //console.log("COMP", old, newv);

    if (_.isEqual(newv, {})) return;
    if (this.action == "list") {
      /*if (!_.isEqual(old, newv)) */ {
        //console.log("CHANGED RELOAD", old, newv, this.paginationActive);
        this.loadAll();
      }
    }
  }

  listaJsonTransform() {
    this.lista = this.lista;
    //Do nothing yet
  }

  addValidation(coluna, regra) {
    this.validationMeta = this.validationMeta || {};
    this.validationMeta[coluna] = this.validationMeta[coluna] || [];
    this.validationMeta[coluna].push(regra);
  }
  addCampoRef(coluna, obj) {
    this.campoRef = this.campoRef || {};
    this.campoRef[coluna] = obj;
  }
  addOrdenacao() {
    this.optionsDrag = {
      dropzoneSelector: "tbody",
      draggableSelector: "tbody tr",
      onDrop: event => {
        this.loadingIntra = true;

        let cns = [];
        for (let cn of event.owner.childNodes) {
          cns.push(cn.getAttribute("trid") * 1);
        }

        let clone = _.clone(this.localsession[this.sid]);
        delete clone["filtro"];

        let credentials = {
          module: this.module,
          orderlist: cns,
          localsession: clone,
          action: "actionOrdenacao"
        };
        Api()
          .post("admin/crud/async", credentials)
          .then(result => {
            this.loadingIntra = false;
          })
          .catch(e => {
            this.loadingIntra = false;
          });
      }
    };
  }

  async saveFiltrosAndCols() {
    this.loadingIntra = true;

    let credentials = {
      module: this.module,
      filtros: this.configcruds[this.module].filtrohide.map(v => v.k),
      colunas: this.configcruds[this.module].displayCols,
      ordecol: this.configcruds[this.module].orderCols,
      action: "actionFiltrosAndCols"
    };
    await Api()
      .post("admin/crud/async", credentials)
      .then(result => {
        this.loadingIntra = false;
      })
      .catch(e => {
        this.loadingIntra = false;
      });
  }

  alterouOrdemCols(e) {
    let cns = [];
    for (let cn of e.owner.children) {
      cns.push(cn.getAttribute("trid"));
    }
    this.configcruds[this.module].orderCols = cns;
    //console.log(this.configcruds[this.module].orderCols);
    Vue.set(this, "configcruds", _.clone(this.configcruds));

    //reordenaCampos
  }

  forceReloadCrud() {
    this.forceReload();
  }

  getComponentParam(campo, prop) {
    if (campo.param == null || campo.param.trim() == "") return null;
    let linhas = campo.param
      .trim()
      .split("\n")
      .map(v =>
        v
          .trim()
          .split("=")
          .map(f => f.trim())
      )
      .filter(x => x[0] == prop);
    if (linhas.length > 0) {
      return linhas[0][1];
    }
    return null;
  }

  full_search_extract(param) {
    let cmp = this.lista.campos.find(c => c.cmp_coluna == "full_search");
    let setado = this.classCrud.getComponentParam(cmp, param);

    return setado;
  }

  async full_search_press() {
    let limite = this.myself.full_search_extract("timer") || 500;

    if (this.full_search_timer != null) {
      clearTimeout(this.full_search_timer);
      this.full_search_timer = null;
    }

    this.full_search_timer = setTimeout(async () => {
      this.full_search_timer = null;

      this.myself.full_search_loading = true;

      await this.forceReload();

      this.myself.full_search_loading = false;
    }, limite);
  }

  loadNextPack($state) {
    this.myself.paginationActive.rowsPerPageReal =
      this.myself.paginationActive.rowsPerPageReal ||
      this.myself.paginationActive.rowsPerPage;
    this.myself.paginationActive.lazyloadpage =
      this.myself.resultset.length * 1;
    this.myself.paginationActive.rowsPerPage =
      this.myself.resultset.length * 1 +
      this.myself.lista.modulo.mod_paginacao * 1;
    this.myself.paginationActive.page = 1;
    if ($state)
      setTimeout(() => {
        $state.loaded();
      }, 1000);
  }

  _dataChanged() {}
  _pageReady() {}
}
